import type { AdminRole, RoleCode } from '@/types/admin'

export const ROLE_PERMISSIONS: Record<RoleCode, string[]> = {
  super_admin: ["admins.force_logout","admins.manage","admins.reset","admins.view","alerts.assign","alerts.close","alerts.export","alerts.handle","alerts.rules.edit","alerts.rules.view","alerts.view","analytics.export","analytics.view","assets.delete","assets.replace","assets.upload","assets.view","audit.export","audit.view","careteam.assign","careteam.manage","careteam.view","content.manage","content.status","content.view","dashboard.view","decoration.manage","decoration.save","decoration.view","devices.bind","devices.command","devices.export","devices.manage","devices.view","drugs.category","drugs.create","drugs.edit","drugs.export","drugs.import","drugs.review.approve","drugs.review.reject","drugs.review.view","drugs.stock","drugs.submit","drugs.view","families.edit","families.export","families.member","families.risk","families.view","health.view","links.manage","links.view","medication.create","medication.edit","medication.export","medication.import","medication.pause","medication.records.correct","medication.records.export","medication.records.view","medication.remind","medication.view","membership.export","membership.manage","membership.order","membership.plan","membership.refund","membership.view","messages.cancel","messages.create","messages.send","messages.view","ops.maintain","ops.view","profile.edit","profile.view","regions.manage","regions.view","reports.generate","reports.send","reports.template","reports.view","roles.manage","roles.view","settings.manage","settings.view","support.assign","support.close","support.handle","support.view","tasks.view","templates.manage","templates.view","users.create","users.edit","users.export","users.status","users.tag","users.view"],
  operations_manager: ["dashboard.view","users.view","users.create","users.edit","users.status","users.tag","users.export","families.view","families.edit","families.member","families.risk","families.export","regions.view","medication.view","medication.create","medication.edit","medication.pause","medication.remind","medication.import","medication.export","medication.records.view","medication.records.export","health.view","alerts.view","alerts.handle","alerts.assign","alerts.export","alerts.rules.view","reports.view","reports.generate","reports.send","careteam.view","careteam.assign","devices.view","drugs.view","messages.view","messages.create","messages.send","messages.cancel","templates.view","templates.manage","content.view","content.manage","content.status","membership.view","membership.plan","membership.manage","membership.order","membership.refund","membership.export","decoration.view","decoration.manage","decoration.save","links.view","links.manage","assets.view","assets.upload","assets.replace","support.view","support.handle","support.assign","support.close","analytics.view","analytics.export","profile.view","profile.edit","tasks.view","regions.manage","alerts.rules.edit","careteam.manage"],
  health_advisor: ["dashboard.view","users.view","families.view","families.edit","families.member","families.risk","medication.view","medication.create","medication.edit","medication.pause","medication.remind","medication.records.view","medication.records.correct","health.view","alerts.view","alerts.handle","alerts.assign","alerts.close","alerts.rules.view","reports.view","reports.generate","reports.send","reports.template","careteam.view","devices.view","messages.view","messages.create","content.view","membership.view","analytics.view","profile.view","profile.edit","tasks.view"],
  drug_librarian: ["dashboard.view","drugs.view","drugs.create","drugs.edit","drugs.stock","drugs.category","drugs.import","drugs.export","drugs.submit","drugs.review.view","assets.view","assets.upload","assets.replace","profile.view","profile.edit","tasks.view"],
  drug_reviewer: ["dashboard.view","drugs.view","drugs.review.view","drugs.review.approve","drugs.review.reject","assets.view","profile.view","profile.edit"],
  support_agent: ["dashboard.view","users.view","families.view","medication.view","medication.records.view","health.view","alerts.view","reports.view","messages.view","messages.create","messages.send","membership.view","membership.order","support.view","support.handle","support.assign","support.close","profile.view","profile.edit","tasks.view"],
  device_ops: ["dashboard.view","users.view","families.view","health.view","alerts.view","devices.view","devices.manage","devices.bind","devices.command","devices.export","ops.view","assets.view","assets.upload","profile.view","profile.edit","tasks.view"],
  analyst: ["dashboard.view","users.view","families.view","medication.records.view","health.view","membership.view","support.view","analytics.view","analytics.export","profile.view","profile.edit"],
  auditor: ["dashboard.view","admins.view","roles.view","settings.view","audit.view","audit.export","ops.view","profile.view","profile.edit"],
}

export const ADMIN_ROLES: AdminRole[] = [
  {
    "code": "super_admin",
    "name": "超级管理员",
    "displayName": "陈知远",
    "dataScope": "all",
    "dataScopeLabel": "全部平台数据",
    "description": "管理全部业务、系统配置、权限、审计与运维；高危操作仍需二次确认并写入审计",
    "entries": [
      "#/dashboard",
      "#/users",
      "#/families",
      "#/regions",
      "#/medication/plans",
      "#/medication/records",
      "#/health/monitoring",
      "#/health/alerts",
      "#/health/alert-rules",
      "#/health/reports",
      "#/health/care-team",
      "#/devices",
      "#/drugs",
      "#/drugs/review",
      "#/messages",
      "#/messages/templates",
      "#/content/tips",
      "#/content/faq",
      "#/membership/plans",
      "#/membership/orders",
      "#/decoration",
      "#/links",
      "#/assets",
      "#/support/tickets",
      "#/support/feedback",
      "#/analytics",
      "#/settings/admins",
      "#/settings/roles",
      "#/settings/general",
      "#/settings/audit-logs",
      "#/settings/operations",
      "#/profile"
    ],
    "permissions": [
      "admins.force_logout",
      "admins.manage",
      "admins.reset",
      "admins.view",
      "alerts.assign",
      "alerts.close",
      "alerts.export",
      "alerts.handle",
      "alerts.rules.edit",
      "alerts.rules.view",
      "alerts.view",
      "analytics.export",
      "analytics.view",
      "assets.delete",
      "assets.replace",
      "assets.upload",
      "assets.view",
      "audit.export",
      "audit.view",
      "careteam.assign",
      "careteam.manage",
      "careteam.view",
      "content.manage",
      "content.status",
      "content.view",
      "dashboard.view",
      "decoration.manage",
      "decoration.save",
      "decoration.view",
      "devices.bind",
      "devices.command",
      "devices.export",
      "devices.manage",
      "devices.view",
      "drugs.category",
      "drugs.create",
      "drugs.edit",
      "drugs.export",
      "drugs.import",
      "drugs.review.approve",
      "drugs.review.reject",
      "drugs.review.view",
      "drugs.stock",
      "drugs.submit",
      "drugs.view",
      "families.edit",
      "families.export",
      "families.member",
      "families.risk",
      "families.view",
      "health.view",
      "links.manage",
      "links.view",
      "medication.create",
      "medication.edit",
      "medication.export",
      "medication.import",
      "medication.pause",
      "medication.records.correct",
      "medication.records.export",
      "medication.records.view",
      "medication.remind",
      "medication.view",
      "membership.export",
      "membership.manage",
      "membership.order",
      "membership.plan",
      "membership.refund",
      "membership.view",
      "messages.cancel",
      "messages.create",
      "messages.send",
      "messages.view",
      "ops.maintain",
      "ops.view",
      "profile.edit",
      "profile.view",
      "regions.manage",
      "regions.view",
      "reports.generate",
      "reports.send",
      "reports.template",
      "reports.view",
      "roles.manage",
      "roles.view",
      "settings.manage",
      "settings.view",
      "support.assign",
      "support.close",
      "support.handle",
      "support.view",
      "tasks.view",
      "templates.manage",
      "templates.view",
      "users.create",
      "users.edit",
      "users.export",
      "users.status",
      "users.tag",
      "users.view"
    ],
    "resources": [
      "全部业务实体",
      "管理员与角色",
      "审计日志",
      "系统参数",
      "运维指标"
    ],
    "allowedActions": [
      "全部业务增删改查",
      "权限与数据范围管理",
      "审计导出",
      "维护模式",
      "角色视角预览"
    ]
  },
  {
    "code": "operations_manager",
    "name": "运营管理员",
    "displayName": "林珊",
    "dataScope": "business",
    "dataScopeLabel": "全部业务数据（不含系统安全）",
    "description": "负责用户、家庭、用药、预警、内容、消息、会员和装修运营，不可管理超级管理员、审计和运维写操作",
    "entries": [
      "#/dashboard",
      "#/users",
      "#/families",
      "#/regions",
      "#/medication/plans",
      "#/medication/records",
      "#/health/monitoring",
      "#/health/alerts",
      "#/health/reports",
      "#/health/care-team",
      "#/devices",
      "#/drugs",
      "#/messages",
      "#/messages/templates",
      "#/content/tips",
      "#/content/faq",
      "#/membership/plans",
      "#/membership/orders",
      "#/decoration",
      "#/links",
      "#/assets",
      "#/support/tickets",
      "#/support/feedback",
      "#/analytics",
      "#/profile",
      "#/health/alert-rules"
    ],
    "permissions": [
      "dashboard.view",
      "users.view",
      "users.create",
      "users.edit",
      "users.status",
      "users.tag",
      "users.export",
      "families.view",
      "families.edit",
      "families.member",
      "families.risk",
      "families.export",
      "regions.view",
      "medication.view",
      "medication.create",
      "medication.edit",
      "medication.pause",
      "medication.remind",
      "medication.import",
      "medication.export",
      "medication.records.view",
      "medication.records.export",
      "health.view",
      "alerts.view",
      "alerts.handle",
      "alerts.assign",
      "alerts.export",
      "alerts.rules.view",
      "reports.view",
      "reports.generate",
      "reports.send",
      "careteam.view",
      "careteam.assign",
      "devices.view",
      "drugs.view",
      "messages.view",
      "messages.create",
      "messages.send",
      "messages.cancel",
      "templates.view",
      "templates.manage",
      "content.view",
      "content.manage",
      "content.status",
      "membership.view",
      "membership.plan",
      "membership.manage",
      "membership.order",
      "membership.refund",
      "membership.export",
      "decoration.view",
      "decoration.manage",
      "decoration.save",
      "links.view",
      "links.manage",
      "assets.view",
      "assets.upload",
      "assets.replace",
      "support.view",
      "support.handle",
      "support.assign",
      "support.close",
      "analytics.view",
      "analytics.export",
      "profile.view",
      "profile.edit",
      "tasks.view",
      "regions.manage",
      "alerts.rules.edit",
      "careteam.manage"
    ],
    "resources": [
      "用户与家庭",
      "用药与健康",
      "药品只读",
      "内容与消息",
      "会员与订单",
      "装修与链接",
      "附件"
    ],
    "allowedActions": [
      "用户与家庭编辑",
      "用药计划维护",
      "预警处理",
      "内容上下线",
      "消息发送",
      "会员方案与退款",
      "装修保存",
      "维护区域主数据与预警规则"
    ]
  },
  {
    "code": "health_advisor",
    "name": "健康顾问",
    "displayName": "张明远",
    "dataScope": "assigned",
    "dataScopeLabel": "分配家庭与本人跟进数据",
    "description": "负责分配家庭的健康监测、预警处理、用药计划、报告与随访，不可导出全量用户或修改系统配置",
    "entries": [
      "#/dashboard",
      "#/users",
      "#/families",
      "#/medication/plans",
      "#/medication/records",
      "#/health/monitoring",
      "#/health/alerts",
      "#/health/alert-rules",
      "#/health/reports",
      "#/health/care-team",
      "#/devices",
      "#/messages",
      "#/content/tips",
      "#/membership/plans",
      "#/analytics",
      "#/profile"
    ],
    "permissions": [
      "dashboard.view",
      "users.view",
      "families.view",
      "families.edit",
      "families.member",
      "families.risk",
      "medication.view",
      "medication.create",
      "medication.edit",
      "medication.pause",
      "medication.remind",
      "medication.records.view",
      "medication.records.correct",
      "health.view",
      "alerts.view",
      "alerts.handle",
      "alerts.assign",
      "alerts.close",
      "alerts.rules.view",
      "reports.view",
      "reports.generate",
      "reports.send",
      "reports.template",
      "careteam.view",
      "devices.view",
      "messages.view",
      "messages.create",
      "content.view",
      "membership.view",
      "analytics.view",
      "profile.view",
      "profile.edit",
      "tasks.view"
    ],
    "resources": [
      "分配家庭",
      "家庭成员健康数据",
      "用药计划与记录",
      "预警与报告",
      "设备只读"
    ],
    "allowedActions": [
      "查看与编辑分配家庭",
      "处理与指派预警",
      "维护用药计划",
      "更正记录",
      "生成与发送报告",
      "发送服务消息"
    ]
  },
  {
    "code": "drug_librarian",
    "name": "药品库管理员",
    "displayName": "赵文博",
    "dataScope": "catalog",
    "dataScopeLabel": "药品主数据与库存",
    "description": "维护药品资料、分类、库存和导入，提交上架审核；不能审核自己提交的药品",
    "entries": [
      "#/dashboard",
      "#/drugs",
      "#/drugs/review",
      "#/assets",
      "#/profile"
    ],
    "permissions": [
      "dashboard.view",
      "drugs.view",
      "drugs.create",
      "drugs.edit",
      "drugs.stock",
      "drugs.category",
      "drugs.import",
      "drugs.export",
      "drugs.submit",
      "drugs.review.view",
      "assets.view",
      "assets.upload",
      "assets.replace",
      "profile.view",
      "profile.edit",
      "tasks.view"
    ],
    "resources": [
      "药品",
      "药品分类",
      "库存",
      "药品附件",
      "审核单只读"
    ],
    "allowedActions": [
      "新增与编辑药品",
      "调整库存",
      "维护分类",
      "导入药库",
      "提交审核"
    ]
  },
  {
    "code": "drug_reviewer",
    "name": "药事审核员",
    "displayName": "孙倩",
    "dataScope": "review",
    "dataScopeLabel": "待审核药品与审核记录",
    "description": "复核药品资料、说明书和变更，执行通过、驳回与下架；不维护库存和分类",
    "entries": [
      "#/dashboard",
      "#/drugs",
      "#/drugs/review",
      "#/profile"
    ],
    "permissions": [
      "dashboard.view",
      "drugs.view",
      "drugs.review.view",
      "drugs.review.approve",
      "drugs.review.reject",
      "assets.view",
      "profile.view",
      "profile.edit"
    ],
    "resources": [
      "审核单",
      "药品只读",
      "说明书附件"
    ],
    "allowedActions": [
      "查看药品与差异",
      "通过审核",
      "驳回审核",
      "下架药品"
    ]
  },
  {
    "code": "support_agent",
    "name": "客服专员",
    "displayName": "周可欣",
    "dataScope": "support",
    "dataScopeLabel": "客服队列与关联用户摘要",
    "description": "处理工单与反馈、发送服务消息、查看会员订单支付问题；不可修改用药、健康数据和药品主数据",
    "entries": [
      "#/dashboard",
      "#/users",
      "#/families",
      "#/medication/plans",
      "#/medication/records",
      "#/health/monitoring",
      "#/health/alerts",
      "#/health/reports",
      "#/messages",
      "#/membership/orders",
      "#/support/tickets",
      "#/support/feedback",
      "#/profile"
    ],
    "permissions": [
      "dashboard.view",
      "users.view",
      "families.view",
      "medication.view",
      "medication.records.view",
      "health.view",
      "alerts.view",
      "reports.view",
      "messages.view",
      "messages.create",
      "messages.send",
      "membership.view",
      "membership.order",
      "support.view",
      "support.handle",
      "support.assign",
      "support.close",
      "profile.view",
      "profile.edit",
      "tasks.view"
    ],
    "resources": [
      "工单",
      "反馈",
      "服务消息",
      "会员订单摘要",
      "用户联系信息（脱敏）"
    ],
    "allowedActions": [
      "受理与指派工单",
      "回复用户",
      "转工单",
      "关闭工单",
      "发送服务消息",
      "查看订单"
    ]
  },
  {
    "code": "device_ops",
    "name": "设备运维",
    "displayName": "高远",
    "dataScope": "device_region",
    "dataScopeLabel": "所辖区域设备与绑定关系",
    "description": "维护设备型号、绑定、在线状态、固件和故障，不读取完整健康指标",
    "entries": [
      "#/dashboard",
      "#/users",
      "#/families",
      "#/health/monitoring",
      "#/health/alerts",
      "#/devices",
      "#/assets",
      "#/settings/operations",
      "#/profile"
    ],
    "permissions": [
      "dashboard.view",
      "users.view",
      "families.view",
      "health.view",
      "alerts.view",
      "devices.view",
      "devices.manage",
      "devices.bind",
      "devices.command",
      "devices.export",
      "ops.view",
      "assets.view",
      "assets.upload",
      "profile.view",
      "profile.edit",
      "tasks.view"
    ],
    "resources": [
      "设备",
      "设备型号",
      "绑定关系",
      "设备告警",
      "运维只读"
    ],
    "allowedActions": [
      "绑定与解绑",
      "下发同步与固件",
      "标记故障",
      "维护型号",
      "查看设备告警"
    ]
  },
  {
    "code": "analyst",
    "name": "数据分析员",
    "displayName": "许文",
    "dataScope": "aggregate",
    "dataScopeLabel": "聚合分析（无个人敏感字段）",
    "description": "查看聚合经营与健康指标并导出汇总报表，不可查看完整手机号、地址和单用户健康明细",
    "entries": [
      "#/dashboard",
      "#/users",
      "#/families",
      "#/medication/records",
      "#/health/monitoring",
      "#/membership/orders",
      "#/support/tickets",
      "#/analytics",
      "#/profile"
    ],
    "permissions": [
      "dashboard.view",
      "users.view",
      "families.view",
      "medication.records.view",
      "health.view",
      "membership.view",
      "support.view",
      "analytics.view",
      "analytics.export",
      "profile.view",
      "profile.edit"
    ],
    "resources": [
      "聚合指标",
      "区域汇总",
      "脱敏订单",
      "服务 SLA"
    ],
    "allowedActions": [
      "查看聚合分析",
      "切换维度",
      "导出聚合报表"
    ]
  },
  {
    "code": "auditor",
    "name": "审计员",
    "displayName": "罗静",
    "dataScope": "audit",
    "dataScopeLabel": "审计与运维只读",
    "description": "只读查看操作日志、管理员、角色和运维状态，不可修改任何业务数据",
    "entries": [
      "#/dashboard",
      "#/settings/admins",
      "#/settings/roles",
      "#/settings/general",
      "#/settings/audit-logs",
      "#/settings/operations",
      "#/profile"
    ],
    "permissions": [
      "dashboard.view",
      "admins.view",
      "roles.view",
      "settings.view",
      "audit.view",
      "audit.export",
      "ops.view",
      "profile.view",
      "profile.edit"
    ],
    "resources": [
      "审计日志",
      "管理员与角色只读",
      "系统参数只读",
      "运维指标"
    ],
    "allowedActions": [
      "查看审计",
      "导出审计",
      "查看权限配置",
      "查看运维状态"
    ]
  }
] as AdminRole[]

export const ROLE_ACCOUNTS: Record<string, RoleCode> = {
  "super_admin": "super_admin",
  "operations_manager": "operations_manager",
  "health_advisor": "health_advisor",
  "drug_librarian": "drug_librarian",
  "drug_reviewer": "drug_reviewer",
  "support_agent": "support_agent",
  "device_ops": "device_ops",
  "analyst": "analyst",
  "auditor": "auditor"
}

export function roleByCode(code: RoleCode): AdminRole {
  const role = ADMIN_ROLES.find(item => item.code === code)
  return role ?? (ADMIN_ROLES[0] as AdminRole)
}

export const ALL_PERMISSIONS: string[] = Array.from(new Set(ADMIN_ROLES.flatMap(role => role.permissions))).sort()

export function hasPermission(permissions: string[], required?: string): boolean {
  if (!required) return true
  return permissions.includes('*') || permissions.includes(required)
}
